import React, { FC, useEffect } from "react";
import Tuition from "../../../components/step3/Tuition";
import OtherFees from "../../../components/step3/OtherFees";
import Calculation from "../../../components/step3/Calculation";
import { IStepTemplate } from "../../../types";
import { useForm, useFormState } from "react-final-form";
import { DurationUnit } from "../../../../../../types";

const Template: FC<IStepTemplate> = ({ stepName }) => {
  const formState = useFormState();
  const { change } = useForm();

  const tuitionDurationUnit =
    formState.values?.[stepName]?.tuitionDurationUnit
      ?.id;

  useEffect(() => {
    if (tuitionDurationUnit === DurationUnit.FULL) {
      change(`${stepName}.tuitionDurationAmount`, null);
    }
  }, [tuitionDurationUnit]);

  return (
    <>
      <Tuition
        name={stepName}
        durationAmountRequired={tuitionDurationUnit !== DurationUnit.FULL}
      />
      <OtherFees
        name={stepName}
        infoIcon={"You need to indicate every fee separately"}
      />
      <Calculation stepName={stepName} />
    </>
  );
};

export default Template;
